<script lang="ts">
	import { Logotype } from '@icons';
	let { title = false }: { title?: boolean } = $props();
</script>

<section data-component="SideBar">
	{#if title}
		<h1 class="inner">
			<Logotype />
		</h1>
	{:else}
		<div class="inner">
			<Logotype />
		</div>
	{/if}
</section>

<style lang="scss">
	section {
		display: none;
		flex-direction: column;
		justify-content: flex-end;
		align-items: stretch;
		min-height: 100%;
		width: var(--nav-height);

		@include md {
			display: flex;
		}
	}

	.inner {
		display: flex;
		height: auto;
		position: sticky;
		bottom: 0;
		padding: calc(var(--nav-height) * 0.27);

		:global(svg) {
			height: auto;
			object-fit: contain;
		}
	}
</style>
